import CustomerSelection from "./CustomerSelection";

const CustomerDetailsSection = ({
  details,
  setDetails,
  errObj,
  setErrObj,
  isDisabled,
}) => {
  return (
    <div className="summary-section">
      <h3 className="summary-section-title">Customer Details</h3>
      <CustomerSelection
        details={details}
        setDetails={setDetails}
        errObj={errObj}
        setErrObj={setErrObj}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default CustomerDetailsSection;
